'use client';

import { Portal, type PortalProps } from '@common/components';

import { SELECTOR } from '@/constants';


export const getMainWrapperElement = () => {
  if (typeof document === 'undefined') return null;

  return document.getElementById(SELECTOR.MAIN_WRAPPER);
};

export const MainWrapperPortal = ({
  children,
  ...props
}: Omit<PortalProps, 'renderTo'>) => {
  return (
    <Portal renderTo={getMainWrapperElement} {...props}>
      {children}
    </Portal>
  );
};
